import Image from '@components/common/Image/Image';
import ChevronIcon from '@src/assets/icons/chevron-down.svg';
import { useUser } from '@src/services/userContext';
import { subjectsAPIMap } from '@src/utils/subjectsMap';
import intlTelInput from 'intl-tel-input';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Field, Grid, Select } from 'theme-ui';
import './SurveyBox.scss';

type SingleQuestionProps = {
  questionIndex: number;
  question: any;
  register: any;
  surveyQuestion: number;
  setSurveyQuestion: any;
  setIsSurveyOpen: any;
  errors: any;
  surveyQuestionsLength: number;
  setValue: any;
  countryCodeInput: any;
  setCountryCodeInput: any;
  getValues: any;
};

function SingleQuestion({
  questionIndex,
  question,
  register,
  surveyQuestion,
  setSurveyQuestion,
  setIsSurveyOpen,
  errors,
  surveyQuestionsLength,
  setValue,
  countryCodeInput,
  setCountryCodeInput,
  getValues,
}: SingleQuestionProps) {
  const { t, i18n } = useTranslation();
  const telRef = useRef(null);
  const [refVisible, setRefVisible] = useState(false);
  const user = useUser();
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  useEffect(() => {
    if (!refVisible) {
      return;
    }
    const input = telRef.current.querySelector('input');
    const preferredCountries: any[] = [];
    if (process.env.GATSBY_DEFAULT_LANGUAGE) {
      preferredCountries.push(process.env.GATSBY_DEFAULT_LANGUAGE);
    }
    const ini = intlTelInput(input, {
      // any initialisation options go here
      preferredCountries: preferredCountries,
      initialCountry: preferredCountries[0],
      separateDialCode: true,
      formatOnDisplay: false,
      customPlaceholder: () => '61234567',
      utilsScript:
        'https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js',
    });
    input.addEventListener('input', () => {
      const a = ini.getSelectedCountryData();
      ini.setNumber(
        input.value?.startsWith('+')
          ? input.value
          : `+${a.dialCode}${input.value}`
      );
    });
    setCountryCodeInput(ini);
  }, [refVisible]);

  const noHelpNeeded = () => {
    if (!user?.userToken) {
    }
    setIsSurveyOpen(false);
    window.sessionStorage.setItem('noSurvey', 'true');
  };
  const submitAnswer = (question, answer, index) => {
    if (index === 0) {
      setSurveyQuestion(surveyQuestion + 1);
      return;
    }
    if (index === surveyQuestionsLength - 1) {
      return;
    }
    register(question);
    if (question === 'subject') {
      setValue(question, subjectsAPIMap[answer.uniqueId]);
    } else {
      setValue(question, answer);
    }
    setSurveyQuestion(surveyQuestion + 1);
  };
  const checkPhone = async (value) => {
    const isValidPhoneNumber = countryCodeInput.isValidNumber();

    if (!isValidPhoneNumber) {
      return t('invalidPhoneNumber');
    }
  };
  function testPhone() {
    return !countryCodeInput.isValidNumber() && !countryCodeInput.telInput.value
      ? t('fieldRequired')
      : t('invalidPhoneNumber');
  }

  return (
    <div
      style={{
        height: surveyQuestion === 0 ? '100%' : 'auto',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {' '}
      <Box
        className={
          surveyQuestion > 0 ? 'question-title' : 'first-question-title'
        }
        sx={{
          width: '100%',
        }}
        dangerouslySetInnerHTML={{
          __html: `${t('survey.' + question.question)}`,
        }}
      ></Box>
      <Box
        className={
          surveyQuestion > 0 ? 'smaller-font-size' : 'larger-font-size'
        }
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: surveyQuestion === 0 ? '100%' : 'auto',
          justifyContent: surveyQuestion === 0 ? 'center' : 'start',
        }}
      >
        {question.answersType === 'button' && (
          <Grid
            columns={[
              1,
              1,
              question.question === 'subject' || question.question === 'grade'
                ? 2
                : 1,
            ]}
            gap={
              question.question === 'subject' || question.question === 'grade'
                ? '10px'
                : '20px'
            }
            style={{ overflow: 'auto', padding: '10px 1px' }}
          >
            {question.options?.map((option, index) => (
              <div
                key={index}
                onClick={
                  questionIndex === 0 && index === 1
                    ? noHelpNeeded
                    : () => {
                        submitAnswer(question.question, option, questionIndex);
                      }
                }
                className={
                  questionIndex === 0 && index === 0
                    ? 'options-button selected center'
                    : question.question === 'subject' &&
                      getValues(question.question) ===
                        subjectsAPIMap[option.uniqueId]
                    ? 'subject-option selected'
                    : question.question === 'subject'
                    ? 'subject-option'
                    : questionIndex > 0 &&
                      option === getValues(question.question)
                    ? 'options-button selected'
                    : !questionIndex
                    ? 'whiteBtn-blueBorder center'
                    : 'options-button'
                }
              >
                {typeof option === 'number' ? (
                  option + ' ' + t('survey.class')
                ) : question.question === 'subject' ? (
                  <Box>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginTop: '0',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                        }}
                      >
                        <div className="subject-icon">
                          <Image
                            sx={{
                              borderRadius: '50%',
                              width: '100%',
                              height: '100%',
                            }}
                            image={option.icon}
                            alt=""
                          />
                        </div>

                        <span>{option.name}</span>
                      </Box>

                      <ChevronIcon />
                    </Box>
                  </Box>
                ) : option ? (
                  t('survey.' + option)
                ) : null}
              </div>
            ))}
          </Grid>
        )}
        {question.answersType === 'input' && (
          <Box className="labels-on-inputs surveyInputs">
            {question.options?.map((option, index) => (
              <div
                key={index}
                style={{
                  flexBasis:
                    surveyQuestion === surveyQuestionsLength - 1
                      ? '662px'
                      : '577px',
                }}
              >
                {option.type === 'phone' && (
                  <Box
                    ref={(el) => {
                      telRef.current = el;
                      setRefVisible(!!el);
                    }}
                  >
                    <Field
                      label={t('survey.' + option.title)}
                      type="tel"
                      {...register(option.title, {
                        required: option.required,
                        validate: (val) => checkPhone(val),
                      })}
                      onKeyUp={(e) => {
                        const inputValue = e.target.value;
                        setValue(option.title, inputValue, {
                          shouldValidate: true,
                        });
                      }}
                      sx={{ padding: '10px 10px 10px 13px' }}
                    ></Field>
                    {errors[option.title] && (
                      <span sx={{ color: 'error' }}>{testPhone()}</span>
                    )}
                  </Box>
                )}
                {option.type === 'email' && (
                  <Box>
                    <Field
                      label={t('email')}
                      type="email"
                      name={option.title}
                      {...register(option.title, {
                        required: t('fieldRequired'),
                        pattern: {
                          value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                          message: t('invalidEmail'),
                        },
                      })}
                      sx={{ padding: '10px 10px 10px 13px' }}
                    ></Field>
                    {errors[option.title]?.message && (
                      <span sx={{ color: 'error' }}>
                        {errors[option.title].message}
                      </span>
                    )}
                  </Box>
                )}
                {option.type === 'text' && (
                  <Box>
                    {option.title === 'discount_code' && (
                      <div
                        style={{
                          marginTop: '30px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '13px',
                        }}
                      >
                        <input
                          id={option.title + '_checkbox'}
                          name={option.title}
                          type="checkbox"
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                        />
                        <div>{t('survey.haveADiscountCode')}</div>
                      </div>
                    )}
                    {isChecked && option.title === 'discount_code' && (
                      <Field
                        label={t('survey.' + option.title)}
                        name={option.title}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          register(option.title, {
                            required: option.required,
                          });
                          setValue(option.title, inputValue, {
                            shouldValidate: true,
                          });
                        }}
                        sx={{ padding: '10px 10px 10px 13px' }}
                      ></Field>
                    )}
                    {option.title !== 'discount_code' && (
                      <Field
                        label={t('survey.' + option.title)}
                        name={option.title}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          register(option.title, {
                            required: option.required,
                          });
                          setValue(option.title, inputValue, {
                            shouldValidate: true,
                          });
                        }}
                        sx={{ padding: '10px 10px 10px 13px' }}
                      ></Field>
                    )}

                    {option.required && errors[option.title] && (
                      <span sx={{ color: 'error' }}>{t('fieldRequired')}</span>
                    )}
                  </Box>
                )}
              </div>
            ))}
          </Box>
        )}
        {question.answersType === 'select' && (
          <Box
            className="labels-on-inputs"
            style={{ display: 'block', maxWidth: '662px' }}
          >
            <Select
              defaultValue=""
              name={question.options.title}
              {...register(question.options.title)}
              sx={{ padding: '10px 10px 10px 13px' }}
            >
              <option hidden value="">
                {t('survey.selectOption')}
              </option>
              {question.options?.answers.map((source, index) => (
                <option key={index} value={source}>
                  {t('survey.' + source)}
                </option>
              ))}
            </Select>
          </Box>
        )}
      </Box>
    </div>
  );
}

export default SingleQuestion;
